import {rumCounterInitJs, rumObservableClassName} from './counter'
import {rumErrorInitJs} from './error'
import type {RumMiddlewareOutput} from './types'

const disableRUM = process.env.NODE_ENV === 'development'
const [commentStart, commentEnd] = disableRUM ? ['/* ', ' */'] : ['', '']

export * from './counter'
export * from './error'
export * from './types'
export * from './utils'

export const rumServiceName = 'delivery'

export const RumObservableRoot: React.FC<React.PropsWithChildren<{}>> = ({children}) => (
  <div className={rumObservableClassName}>{children}</div>
)

export const Rum: React.FC<{nonce?: string; config: RumMiddlewareOutput}> = ({
  nonce,
  config: {config, inlineJs, bundleSrc},
}) => (
  <>
    <script dangerouslySetInnerHTML={{__html: inlineJs.rumCounter}} nonce={nonce} />
    <script dangerouslySetInnerHTML={{__html: inlineJs.errorCounter}} nonce={nonce} />
    <script
      dangerouslySetInnerHTML={{__html: [commentStart, rumCounterInitJs(config), commentEnd].join('')}}
      nonce={nonce}
    />
    {inlineJs.mfpObserver && (
      <script
        dangerouslySetInnerHTML={{__html: [commentStart, inlineJs.mfpObserver, commentEnd].join('')}}
        nonce={nonce}
      />
    )}
    {!disableRUM && <script nonce={nonce} src={bundleSrc} />}
    <script
      dangerouslySetInnerHTML={{__html: [commentStart, rumErrorInitJs(config), commentEnd].join('')}}
      nonce={nonce}
    />
  </>
)
